import { render, staticRenderFns } from "./QuestionComponent.vue?vue&type=template&id=02788555&scoped=true"
import script from "./QuestionComponent.vue?vue&type=script&lang=js"
export * from "./QuestionComponent.vue?vue&type=script&lang=js"
import style0 from "./QuestionComponent.vue?vue&type=style&index=0&id=02788555&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02788555",
  null
  
)

export default component.exports